import { orchestrator } from "satcheljs";
import { TeamDataService } from "sh-services";
import deleteSchedule from "../actions/deleteSchedule";

/**
 * Delete schedule from team
 */
export const deleteScheduleOrchestrator = orchestrator(deleteSchedule,
    actionMessage => {
        TeamDataService.deleteSchedule(actionMessage.teamInfo).then((team) => {
            actionMessage.onDeleteScheduleSuccess(team);
        }).catch((error) => {
            actionMessage.onDeleteScheduleFailure(error);
        });
    }
);